import { Icon } from '@buggy/shared'
import { Button, Flex, Skeleton } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import KolActionsDropdown, {
  type KolActionsDropdownProps,
} from '@/components/kol/navigation/kol-actions-dropdown'
import routes from '@/hooks/use-authorization/routes'
import { useDispatch } from '@/hooks/use-dispatch'
import { useSelector } from '@/hooks/use-selector'
import { useIntl } from '@/i18n/hooks/use-intl'
import { setOpen } from '@/store/kol-cooperation-detail-drawer'
import { KolSchemaModel } from '@/types/schema/kol-schema'

interface NavigationProps {
  kolId: string
  kolInfo?: KolSchemaModel
  isKolInfoLocked: boolean
  from?: KolActionsDropdownProps['from']
}

const Navigation: FunctionComponent<NavigationProps> = ({
  kolId,
  kolInfo,
  isKolInfoLocked,
  from,
}) => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const dropdownActions = useSelector(
    (state) => state.kolCooperationDetailDrawer.dropdownActions,
  )

  return (
    <Box>
      <Button
        icon={<Icon fontSize={16} name='chevrons-left' />}
        style={{ padding: 0 }}
        type='link'
        onClick={(): void => {
          dispatch(setOpen(false))
        }}
      >
        {formatMessage({ id: 'general:go_back_act' })}
      </Button>
      <Flex gap={10}>
        <Button
          href={routes.kolId.stringifyUrl(
            {
              kolId,
            },
            {
              isClickedFromDrawer: true,
              from,
            },
          )}
          target='_blank'
          type='primary'
        >
          {formatMessage({ id: 'general:view_kol_detail_act' })}
        </Button>
        {kolInfo ? (
          <KolActionsDropdown
            isClickedFromDrawer
            actions={dropdownActions}
            from={from}
            isKolInfoLocked={isKolInfoLocked}
            kolInfo={kolInfo}
          />
        ) : (
          <Skeleton.Avatar active shape='square' style={{ borderRadius: 4 }} />
        )}
      </Flex>
    </Box>
  )
}

const Box = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }): string => theme.colors.border.border};
`

export default Navigation
